module.exports = __webpack_public_path__ + "img/ctrl-fswap-1.9b88f485.svg";